var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useFragment } from '@apollo/client/react';
import { Menu } from '@pocketlaw/tetris';
import { format, isValid } from 'date-fns';
import { useField, useFormikContext } from 'formik';
import { localeConfig } from 'shared/domains/languages';
import { AddMetadataLabelFragmentFragmentDoc } from './AddMetadataLabelFragment.gql';
import { RemoveSelection } from './RemoveSelection';
export function AddMetadataDateSelection(props) {
    const { from } = props;
    const { submitForm } = useFormikContext();
    const [field, , helpers] = useField('value');
    const { data, complete } = useFragment({
        from,
        fragment: AddMetadataLabelFragmentFragmentDoc,
    });
    const localeCode = localeConfig.getActiveLocale().code;
    const value = field.value && isValid(new Date(field.value)) ? new Date(field.value) : undefined;
    const handleDateChange = (newDate) => __awaiter(this, void 0, void 0, function* () {
        const formattedDate = format(newDate, 'yyyy-MM-dd');
        helpers.setValue(formattedDate);
        return submitForm();
    });
    if (!complete) {
        return null;
    }
    return (<Menu.ItemNested target={data.label}>
      <Menu.Calendar locale={localeCode} value={value} onChange={handleDateChange}/>
      <RemoveSelection />
    </Menu.ItemNested>);
}
